import React, { Suspense, useCallback } from "react";
import "components/styles/variables.css";
import "./App.scss";
import { BrowserRouter } from "react-router-dom";
import { ApplicationFooter } from "components/footer/ApplicationFooter";
import { ApplicationHeader } from "components/header/ApplicationHeader";
import { AppHooks } from "components/app/AppHooks";
import { AppContent } from "components/app/AppContent";
import GoCtrl from "components/ads/goCtrl";
import { className } from "utils/strings";
import { setAppHeight } from "utils/hacks";
import { PopupDispatcher } from "components/popups/PopupDispatcher";
import { ResponseMessage } from "components/UI/ResponseMessage";
import { Partytown } from "@builder.io/partytown/react";
import { metrics } from "utils/metrics";

metrics.init();

window.addEventListener("resize", setAppHeight);
setAppHeight();

const App: React.FC = () => {
  const isSpecialPage = useCallback(() => {
    return window.location.pathname.indexOf("/ifr/") === 0;
  }, []);

  const showNavigation = !isSpecialPage();

  return (
    <div className={className({
      "App": true,
      "nav": showNavigation,
      "nonav": !showNavigation,
    })}>
      <BrowserRouter>
        {showNavigation && <Suspense><ApplicationHeader /></Suspense>}

        <AppContent />

        {showNavigation && <Suspense><ApplicationFooter /></Suspense>}

        <PopupDispatcher />
        <GoCtrl />
        <AppHooks />
        <Partytown debug={import.meta.env.REACT_APP_ENV === "development"} forward={["dataLayer.push"]}/>
      </BrowserRouter>

      <ResponseMessage />
    </div>
  );
};

export default App;
